/*eslint-disable*/
import React from "react";

import IndexNavbar from "components/navbars/IndexNavbar.js";
import Footer from "components/footers/Footer.js";

export default function Index() {
  return (
    <>
      <IndexNavbar fixed />
      <img
        className="absolute filter blur-sm"
        src={require("assets/img/logistica.jpg")}
        alt="..."
      />
      <section className="header relative pt-16 items-center flex h-screen max-h-860-px">
        <div className="container mx-auto flex flex-wrap items-center">
          {/* Card Principal */}
          <div className="relative w-full shadow-lg rounded-lg bg-white p-6 flex items-center">
            {/* Texto e Botões */}
            <div className="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4">
              <div className="pt-32 sm:pt-0">
                {/* Título */}
                <h2 className="font-semibold text-4xl text-blueGray-600">
                  LC Transportes
                </h2>
                {/* Descrição */}
                <p className="mt-4 text-lg leading-relaxed text-blueGray-500">
                  A logística da Bahia ganha agilidade e confiabilidade, garantindo a entrega de sua carga com segurança e eficiência em diversas localidades, de todo o nordeste do Brasil.
                </p>
                {/* Botões de Ação */}
                <div className="mt-12 flex space-x-4">
                  {/* Botão "Contatos" */}
                  <a
                    onClick={() =>
                      document
                        .getElementById('contatos-section')
                        .scrollIntoView({ behavior: 'smooth' })
                    }
                    className="get-started text-white font-bold px-6 py-4 rounded bg-lightBlue-500 active:bg-lightBlue-600 uppercase text-sm shadow hover:shadow-lg ease-linear transition-all duration-150 cursor-pointer"
                  >
                    Contatos
                  </a>

                  {/* Botão "Saiba Mais" */}
                  <a
                    onClick={() =>
                      document
                        .getElementById('saiba-mais-section')
                        .scrollIntoView({ behavior: 'smooth' })
                    }
                    className="github-star text-white font-bold px-6 py-4 rounded bg-blueGray-700 active:bg-blueGray-600 uppercase text-sm shadow hover:shadow-lg ease-linear transition-all duration-150 cursor-pointer"
                  >
                    Saiba Mais
                  </a>
                </div>
              </div>
            </div>

            {/* Imagem ao lado do texto */}
            <div className="w-full md:w-4/12 lg:w-6/12 xl:w-6/12 px-4 flex justify-end">
              <img
                style={{ width: '450px', height: 'auto' }}
                src={require("assets/img/app.png")}
                alt="Imagem ilustrativa"
              />
            </div>
          </div>
        </div>






      </section>

      <section className="mt-48 md:mt-40 pb-40 relative bg-blueGray-100">
        <div
          className="-mt-20 top-0 bottom-auto left-0 right-0 w-full absolute h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-blueGray-100 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
        <div id="saiba-mais-section" className="container mx-auto">
          <div className="flex flex-wrap items-center">
            <div className="w-10/12 md:w-6/12 lg:w-4/12 px-12 md:px-4 mr-auto ml-auto">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-lightBlue-500">
                <img
                  alt="..."
                  src={require("assets/img/1.png")}
                  className="w-full align-middle rounded-t-lg"
                />
                <blockquote className="relative p-8 mb-4">
                  <svg
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 583 95"
                    className="absolute left-0 w-full block h-95-px -top-94-px"
                  >
                    <polygon
                      points="-30,95 583,95 583,65"
                      className="text-lightBlue-500 fill-current"
                    ></polygon>
                  </svg>
                  <h4 className="text-xl font-bold text-white">
                    Qualificação
                  </h4>
                  <p className="text-md font-light mt-2 text-white">
                    Após uma análise detalhada do mercado de transporte para entregas e-commerce, identificamos que agilidade, pontualidade e qualidade são os fatores mais valorizados pelos clientes. Esses elementos se tornaram requisitos essenciais para garantir a satisfação do consumidor final ao receber seu produto.
                  </p>
                </blockquote>
              </div>
            </div>

            <div className="w-full md:w-6/12 px-4">
              <div className="flex flex-wrap">
                <div className="w-full md:w-6/12 px-4">
                  <div className="relative flex flex-col mt-4">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                        <i className="fas fa-sitemap"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">
                        Parceiras
                      </h6>
                      <p className="mb-4 text-blueGray-500">
                        Temos diversas parceiras trabalhando junto com a LC Transportes.
                      </p>
                    </div>
                  </div>
                  <div className="relative flex flex-col min-w-0">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                        <i className="fas fa-drafting-compass"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">
                        Abrangencia
                      </h6>
                      <p className="mb-4 text-blueGray-500">
                        Atendemos diversas cidades no nordeste, conectando pessoas e negócios com excelência.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-6/12 px-4">
                  <div className="relative flex flex-col min-w-0 mt-4">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                        <i className="fas fa-newspaper"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">Transportes</h6>
                      <p className="mb-4 text-blueGray-500">
                        Atende formatos como First-Mile, Last-Mile, Middle-Mile e Line-Haul com ampla expertise.
                      </p>
                    </div>
                  </div>
                  <div className="relative flex flex-col min-w-0">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                        <i className="fas fa-file-alt"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">
                        Feitos
                      </h6>
                      <p className="mb-4 text-blueGray-500">
                        Realizamos uma média mensal de 250 mil pacotes entregues com 98% de prazos cumpridos.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mx-auto overflow-hidden pb-20">
          <div className="flex flex-wrap items-center">
            <div className="w-full md:w-4/12 px-12 md:px-4 ml-auto mr-auto mt-48">
              <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                <i className="fas fa-handshake text-xl"></i>
              </div>
              <h3 className="text-3xl mb-2 font-semibold leading-normal">
                Nossas Parceiras
              </h3>
              <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600">
                Contamos com diversas parcerias estratégicas que fortalecem nossa operação e garantem um serviço ainda mais eficiente e de qualidade para nossos clientes.
              </p>
              <div className="block pb-6">
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  LOGGI
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  SHOPEE
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  MERCADO LIVRE
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  ANJUN
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  IMILE
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  JADLOG
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  AMAZON
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  SHIPPIFY
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  PATRUS
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  TOTAL EXPRESS
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  FEDEX
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  NTLOG
                </span>

              </div>

            </div>

            <div className="w-full md:w-5/12 px-4 mr-auto ml-auto mt-32">
              <div className="relative flex flex-col min-w-0 w-full mb-6 mt-48 md:mt-0">

                <img
                  alt="..."
                  src={require("assets/img/anjun.jpg")}
                  className="w-full align-middle rounded-lg absolute shadow-lg -top-anjun-px"
                />
                <img
                  alt="..."
                  src={require("assets/img/amazon.png")}
                  className="w-full align-middle rounded-lg absolute shadow-lg -top-amazon-px"
                />
                <img
                  alt="..."
                  src={require("assets/img/shopee.jpg")}
                  className="w-full align-middle rounded-lg absolute shadow-lg -top-loggi-px z-2"
                />
                <img
                  alt="..."
                  src={require("assets/img/loggi.png")}
                  className="w-full align-middle rounded-lg absolute shadow-2xl max-w-200-px -left-50-px top-25-px"
                />
                <img
                  alt="..."
                  src={require("assets/img/imile.png")}
                  className="w-full align-middle rounded-lg absolute shadow-2xl max-w-200-px  left-195-px top-95-px"
                />
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center pt-32">
          <div className="w-full md:w-6/12 px-4 mr-auto ml-auto mt-32">
  <div className="justify-center flex flex-wrap relative">
    <div className="my-4 w-full lg:w-6/12 px-4">

      <img
        alt="..."
        className="w-full align-middle rounded-lg absolute shadow-lg -top-truck1-px max-w-180-px hidden md:block"
        src={require("assets/img/2.jpg")}
      />
      <img
        alt="..."
        className="w-full align-middle rounded-lg absolute shadow-lg -top-truck2-px max-w-180-px hidden md:block"
        src={require("assets/img/3.jpg")}
      />
      <img
        alt="..."
        className="w-full align-middle rounded-lg absolute shadow-lg -top-truck3-px max-w-180-px hidden md:block"
        src={require("assets/img/4.jpg")}
      />

    </div>
  </div>
</div>


            <div className="w-full md:w-4/12 px-12 md:px-4 ml-auto mr-auto mt-48">
              <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                <i className="fas fa-truck-moving text-xl"></i>
              </div>
              <h3 className="text-3xl mb-2 font-semibold leading-normal">
                Transportes e Fretes
              </h3>
              <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600">
                Atualmente trabalhamos com veículos tipo: Motos, Carros de Passeio, Fiorinos, Vans, 3/4 e Truck para atender toda extensa malha de entregas Last Mile, Midle Mile e Line Haul atual.
              </p>
              <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600">
                A quantidade é dimensionada levando-se em consideração os prazos de entregas e os volumes disponíveis para cada rota.
              </p>
              <div className="block pb-6">
                <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-white uppercase last:mr-0 mr-2 mt-2">
                  Transportes
                </span>

              </div>

            </div>
          </div>
        </div>

        <div className="container mx-auto px-4 pb-32 pt-48">
          <div className="items-center flex flex-wrap">
            <div className="w-full md:w-5/12 ml-auto px-12 md:px-4">
              <div className="md:pr-12">
                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                  <i className="fas fa-file-alt text-xl"></i>
                </div>
                <h3 className="text-3xl font-semibold">
                  Mais 300 cidades
                </h3>
                <p className="mt-4 text-lg leading-relaxed text-blueGray-500">
                  Nossa empresa está comprometida em expandir sua rede de entregas e já atende mais de 300 cidades em todo o país. Com uma infraestrutura robusta e uma equipe dedicada, garantimos que nossos serviços sejam rápidos, seguros e eficazes, alcançando os mais diversos destinos e superando as expectativas de nossos clientes. Estamos constantemente inovando e aprimorando nossas operações para assegurar que cada entrega seja feita com excelência, contribuindo para o crescimento e satisfação dos nossos parceiros.
                </p>
                <ul className="list-none mt-6">

                  <li className="py-2">
                    <div className="flex items-center">
                      <div>
                        <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blueGray-500 bg-blueGray-50 mr-3">
                          <i className="far fa-paper-plane"></i>
                        </span>
                      </div>
                      <div>
                        <h4 className="text-blueGray-500">
                          Bahia, Ceará, Maranhão, Piauí...
                        </h4>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div className="w-full md:w-6/12 mr-auto px-4 pt-24 md:pt-0">
              <img
                alt="..."
                className="max-w-full rounded-lg shadow-xl"
                style={{
                  transform:
                    "scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg)",
                }}
                src="/map.png"
              />
            </div>
          </div>
        </div>

        <div className="justify-center text-center flex flex-wrap mt-24">
          <div className="w-full md:w-6/12 px-12 md:px-4">
            <h2 className="font-semibold text-4xl">Sobre a Nossa Equipe</h2>
            <p className="text-lg leading-relaxed mt-4 mb-4 text-blueGray-500">

              Uma equipe integrada, composta por entregadores especializados, operação eficiente, suporte ágil e gestores focados, garantindo entregas de qualidade, cumprimento de prazos e total satisfação do consumidor.
            </p>
          </div>
        </div>
      </section>

      <section className="block relative z-1 bg-blueGray-600">
        <div className="container mx-auto">
          <div className="justify-center flex flex-wrap">
            <div className="w-full lg:w-12/12 px-4  -mt-24">
              <div className="flex flex-wrap">
                <div className="w-full lg:w-4/12 px-4">
                  <h5 className="text-xl font-semibold pb-4 text-center">
                    MOTORISTAS
                  </h5>

                  <div className="hover:-mt-4 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150">
                    <img
                      alt="..."
                      className="align-middle border-none max-w-full h-auto rounded-lg"
                      src="https://exametoxicologico.labet.com.br/wp-content/uploads/2018/04/190601-vida-de-motorista-conheca-a-rotina-de-quem-atua-nessa-profissao.jpg"
                    />
                  </div>

                </div>

                <div className="w-full lg:w-4/12 px-4">
                  <h5 className="text-xl font-semibold pb-4 text-center">
                    ADMINISTRATIVO
                  </h5>

                  <div className="hover:-mt-4 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150">
                    <img
                      alt="..."
                      className="align-middle border-none max-w-full h-auto rounded-lg"
                      src="https://www.csacademy.com.br/wp-content/uploads/2024/05/SAC.webp"
                    />
                  </div>

                </div>

                <div className="w-full lg:w-4/12 px-4">
                  <h5 className="text-xl font-semibold pb-4 text-center">
                    EXPEDIÇÃO
                  </h5>

                  <div className="hover:-mt-4 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150">
                    <img
                      alt="..."
                      className="align-middle border-none max-w-full h-auto rounded-lg"
                      src="https://www.totvs.com/wp-content/uploads/2023/10/expedicao.jpg"
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-blueGray-600 overflow-hidden">
        <div id="contatos-section" className="container mx-auto pb-64">
          <div className="flex flex-wrap justify-center">
            <div className="w-full md:w-5/12 px-12 md:px-4 ml-auto mr-auto md:mt-64">
              <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                <i className="fas fa-code-branch text-xl"></i>
              </div>
              <h3 className="text-3xl mb-2 font-semibold leading-normal text-white">
                Contatos
              </h3>
              <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-400">
                Entre em contato conosco e descubra como a LC Transportes pode atender às suas necessidades de transporte de carga com agilidade e eficiência. Estamos prontos para ajudar!
              </p>
              <p className="text-lg font-light leading-relaxed mt-0 mb-4 text-blueGray-400">

              </p>
              <a
                href="https://wa.me/5575999138331?text=Olá,%20gostaria%20de%20saber%20mais%20sobre%20seus%20serviços."
                target="_blank"
                className="github-star mt-4 inline-block text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-blueGray-700 active:bg-blueGray-600 uppercase text-sm shadow hover:shadow-lg"
              >
                Whatsapp
              </a>
              <a
                href="mailto:roberto.fonseca@lc-transportes.com?subject=Olá%20Mundo&body=Gostaria%20de%20mais%20informações."
                target="_blank"
                className="github-star mt-4 inline-block text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-blueGray-700 active:bg-blueGray-600 uppercase text-sm shadow hover:shadow-lg"
              >
                EMAIL
              </a>
            </div>

            <div className="w-full md:w-4/12 px-4 mr-auto ml-auto mt-32 relative">
              <i className="fa fa-envelope text-blueGray-700 absolute -top-150-px -right-100 left-auto opacity-80 text-55"></i>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-16 bg-blueGray-200 relative pt-32">
        <div
          className="-mt-20 top-0 bottom-auto left-0 right-0 w-full absolute h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-blueGray-200 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>

        <div id="info-section" className="container mx-auto">
          <div className="flex flex-wrap justify-center bg-white shadow-xl rounded-lg -mt-64 py-16 px-12 relative z-10">
            <div className="w-full text-center lg:w-8/12">

              <h3 className="font-semibold text-3xl">
                NOSSA HISTORIA
              </h3>
              <p className="text-blueGray-500 text-lg leading-relaxed mt-4 mb-4">
                A LC Transportes é uma empresa especializada no transporte de cargas com atuação em todo o território nacional, fundada para atender com excelência tanto o transporte de cargas pesadas quanto entregas fracionadas, adaptando-se às necessidades específicas de cada material transportado.
                Identificando a crescente demanda no setor de e-commerce, ampliamos nosso foco para entregas com veículos utilitários, de passeio e motos, oferecendo soluções completas para nossos parceiros. Nos últimos 5 anos, desenvolvemos uma ampla malha de entregas nos formatos First-Mile, Last-Mile, Middle-Mile e Line Haul, consolidando nossa expertise operacional e contando com gestores altamente qualificados.
                Atualmente, realizamos uma média mensal de 250 mil pacotes entregues em nossas bases ativas, mantendo um índice superior a 98% de prazos cumpridos e um nível mínimo de devoluções, garantindo eficiência e confiabilidade em todas as operações.</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
